export const getPermissionResponseValue = (isGranted: boolean): 'Granted' | 'Denied' =>
  isGranted ? 'Granted' : 'Denied';
